import localFont from 'next/font/local'

const ibmPlexSansCssVariable = '--font-ibm-plex-sans'
const ibmPlexSans = localFont({
  src: [
    {
      path: './IBMPlexSans-Thin.woff',
      weight: '100',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-ThinItalic.woff',
      weight: '100',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-ExtraLight.woff',
      weight: '200',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-ExtraLightItalic.woff',
      weight: '200',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-Light.woff',
      weight: '300',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-LightItalic.woff',
      weight: '300',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-Regular.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-Italic.woff',
      weight: '400',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-Medium.woff',
      weight: '500',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-MediumItalic.woff',
      weight: '500',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-SemiBold.woff',
      weight: '600',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-SemiBoldItalic.woff',
      weight: '600',
      style: 'italic',
    },
    {
      path: './IBMPlexSans-Bold.woff',
      weight: '700',
      style: 'normal',
    },
    {
      path: './IBMPlexSans-BoldItalic.woff',
      weight: '700',
      style: 'italic',
    },
  ],
  display: 'swap',
  variable: '--font-ibm-plex-sans',
})

export { ibmPlexSans, ibmPlexSansCssVariable }
